import AiAskBarComposerPanel from './AiAskBarComposerPanel'

export default function AiAskBarComposerPanelBranch(props) {
  return <AiAskBarComposerPanel {...props} />
}
